import { createAsyncThunk } from '@reduxjs/toolkit'
import { ResolveUrl, UpdateClaims } from 'features/firebase-app'
import { getBearerToken } from '../../application/application-slice'

export const init_customer_administrator = createAsyncThunk<any, any, any>(
  'auto/init/customer/administrator',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      try {
        let response = await fetch(
          ResolveUrl('auto/init/customer/administrator'),
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${bearToken}`,
              'Access-Control-Allow-Origin': '*',
            },
            body: JSON.stringify(params),
          },
        )
        let res = await response.json()
        if (params && params.callback) {
          params.callback(true, res)
        }
        await UpdateClaims()
        return res
      } catch (e) {
        if (params && params.callback) {
          params.callback(false, e)
        }
      }
    } else {
      if (params && params.callback) {
        params.callback(false)
      }
      throw 'not signed in'
    }
  },
)

export const get_customer_settings_as_admin = createAsyncThunk<any, any, any>(
  'auto/get/customer/settings/as/admin',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      try {
        let response = await fetch(
          ResolveUrl('auto/get/customer/settings/as/admin'),
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${bearToken}`,
              'Access-Control-Allow-Origin': '*',
            },
            body: JSON.stringify(params),
          },
        )
        let res = await response.json()
        if (params && params.callback) {
          params.callback(true, res)
        }

        return res
      } catch (e) {
        if (params && params.callback) {
          params.callback(false, e)
        }
      }
    } else {
      if (params && params.callback) {
        params.callback(false)
      }
      throw 'not signed in'
    }
  },
)
